import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { dramatstraAPI } from '../services/api';

export function useWatchlist(params?: { page?: number; limit?: number }) {
  return useQuery({
    queryKey: ['watchlist', params?.page, params?.limit],
    queryFn: async () => {
      const response = await dramatstraAPI.watchlist.list(params);
      return response.data;
    },
    staleTime: 2 * 60 * 1000,
  });
}

export function useAddToWatchlist() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (seriesId: string) => {
      const response = await dramatstraAPI.watchlist.add({ seriesId });
      return response.data;
    },
    onSuccess: (_, seriesId) => {
      queryClient.setQueryData(['seriesDetail', seriesId], (old: any) => ({
        ...old,
        in_watchlist: true,
      }));
    },
  });
}

export function useRemoveFromWatchlist() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (seriesId: string) => {
      await dramatstraAPI.watchlist.remove(seriesId);
    },
    onSuccess: (_, seriesId) => {
      queryClient.setQueryData(['seriesDetail', seriesId], (old: any) => ({
        ...old,
        in_watchlist: false,
      }));
    },
  });
}
